export default __webpack_public_path__ + "static/media/takeoutfinder.1608fae7.png";